import { CheckIntegrationOvermind } from 'domain/usecases/eligibility/check-integration-overmind'
import { CreateConsultEligibility } from 'domain/usecases/eligibility/create-consult-eligibility'
import { CreateEligibility } from 'domain/usecases/eligibility/create-eligibility'
import { EligibilityCheck } from 'domain/usecases/eligibility/eligibility-check'
import { FindConsultsEligibility } from 'domain/usecases/eligibility/find-consults-eligibility'
import { UpdateEligibilityDocument } from 'domain/usecases/eligibility/update-eligibility-document'
import { makeAutoObservable } from 'mobx'

type Services = {
  eligibilityCheck: EligibilityCheck
  checkIntegrationOvermind: CheckIntegrationOvermind
  findConsultsEligibility: FindConsultsEligibility
  createConsultEligibility: CreateConsultEligibility
  createEligibility: CreateEligibility
  updateEligibilityDocument: UpdateEligibilityDocument
}

export class EligibilityService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async eligibilityCheck(
    data: EligibilityCheck.Data,
    params: EligibilityCheck.Params
  ): Promise<EligibilityCheck.Model> {
    return this.services.eligibilityCheck.check(data, params)
  }

  async checkIntegrationOvermind(
    surgical_order_id: number
  ): Promise<CheckIntegrationOvermind.Model> {
    return this.services.checkIntegrationOvermind.check(surgical_order_id)
  }

  async findConsultsEligibility(
    surgical_order_id: number
  ): Promise<FindConsultsEligibility.Model> {
    return this.services.findConsultsEligibility.find(surgical_order_id)
  }

  async createConsultEligibility(
    params: CreateConsultEligibility.Params
  ): Promise<CreateConsultEligibility.Model> {
    return this.services.createConsultEligibility.create(params)
  }

  async createEligibility(
    params: CreateEligibility.Params
  ): Promise<CreateEligibility.Model> {
    return this.services.createEligibility.create(params)
  }

  async updateEligibilityDocument(
    params: UpdateEligibilityDocument.Params
  ): Promise<UpdateEligibilityDocument.Model> {
    return this.services.updateEligibilityDocument.update(params)
  }
}

export default EligibilityService
